<template>
  <div :class="name">
    <el-table :id="`${name}`"
              :class="`${name}`"
              :data="computedData"
              border
              v-loading="isLoading"
              :row-class-name="({ row }) => row.id"
              :row-key="row => row.id"
              :expand-row-keys="expandRowKeys"
              @expand-change="handleSelectService"
              size="mini"
              :fit="true">
      <el-table-column type="expand" :column-key="`${'expand'}`">
        <template slot-scope="props">
          <div>
            <h4>서비스에서 사용되는 도메인</h4>
            <el-row :gutter="24">
              <el-col v-for="(range, rangeIndex) in selectService.range_group"
                      :key="`range_${rangeIndex}`"
                      :xs="8" :sm="6" :md="3" :lg="3" :xl="1" style="padding-bottom: 1rem">
                <span>{{range.full_name}}</span><br>
                ( <span v-for="(tag, tagIndex) in range.tag"
                        :key="`tag_${tagIndex}`"
                        class="tag"> #{{tag}}</span> )
              </el-col>
            </el-row>
          </div>
          <div>
            <h4>서비스에서 사용되는 권한</h4>
            <ul>
              <li v-for="(action, id) in selectService.action_group"
                  :key="id">
                {{action.title}} : {{action.explain}}
              </li>
            </ul>
          </div>
        </template>
      </el-table-column>
      <template v-for="(key) in localIndicator">
        <el-table-column :prop="`${key}`"
                         :key="key"
                         :label="key"
                         :sortable="true"
                         :column-key="key">
          <template slot-scope="scope">
            <template v-if="key === 'name'">
              <span style="background-color: white">{{scope.row.name}}</span>
            </template>
            <template v-else-if="key === 'rang_tags'">
              <span v-for="(tag, index) of scope.row[key]" :key="index">
                {{tag}},
              </span>
            </template>
            <template v-else>
              {{scope.row[key]}}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import filterTeamView from '@/filters/getTeamViewData';
import filterJobView from '@/filters/getJobViewData';

export default {
  filters: {
    filterTeamView,
    filterJobView,
  },
  components: {

  },
  computed: {
    ...mapGetters([
      'services',
      'isLoading',
    ]),
    computedData() {
      const serviceList = [];

      Object.keys(this.services).forEach((serviceId) => {
        serviceList.push(this.services[serviceId]);
      });
      return serviceList;
    },
  },
  methods: {
    handleSelectService(row) {
      this.handleExpandChange(row);
      this.selectedServiceSetting(row);
    },

    handleExpandChange(row) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];

      this.expandRowKeys = id === lastId ? [] : [id];
    },

    selectedServiceSetting(row, isUpdate) {
      if (this.selectedMember) {
        if (this.selectedMember.id !== row.id) {
          this.makeServiceViewData(row);
        } else if (isUpdate) {
          this.makeServiceViewData(row, isUpdate);
        } else {
          this.makeServiceViewData(null);
        }
      } else {
        this.makeServiceViewData(row);
      }
    },

    makeServiceViewData(row) {
      this.selectService = row;
    },
  },
  data() {
    return {
      name: 'ServiceList',
      expandRowKeys: [],
      selectedRow: null,
      selectService: null,
      localIndicator: [
        // 'id',
        // 'company',
        'name',
        // 'domain',
        'explain',
        'rang_tags',
        // 'range_group',
        // 'action_group',
      ],
    };
  },
};
</script>
<style lang="scss">
  .tag {
    color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceList.vue